 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"coreui-coreui-module-ngfactory":"coreui-coreui-module-ngfactory","default~app-modules-app-version-app-version-module-ngfactory~app-views-setting-global-setting-global~f1cbe40b":"default~app-modules-app-version-app-version-module-ngfactory~app-views-setting-global-setting-global~f1cbe40b","common":"common","app-views-setting-global-setting-global-module-ngfactory":"app-views-setting-global-setting-global-module-ngfactory","views-dashboard-dashboard-module-ngfactory":"views-dashboard-dashboard-module-ngfactory","views-forgot-password-forgot-password-module-ngfactory":"views-forgot-password-forgot-password-module-ngfactory","views-login-login-module-ngfactory":"views-login-login-module-ngfactory","views-password-reset-password-reset-module-ngfactory":"views-password-reset-password-reset-module-ngfactory","default~app-modules-app-version-app-version-module-ngfactory~bank-bank-module-ngfactory~kyc-kyc-modu~3e2f785a":"default~app-modules-app-version-app-version-module-ngfactory~bank-bank-module-ngfactory~kyc-kyc-modu~3e2f785a","app-modules-app-version-app-version-module-ngfactory":"app-modules-app-version-app-version-module-ngfactory","bank-bank-module-ngfactory":"bank-bank-module-ngfactory","views-staff-staff-module-ngfactory":"views-staff-staff-module-ngfactory","default~kyc-kyc-module-ngfactory~modules-crowd-funding-crowd-funding-module-ngfactory~modules-loan-l~298e85a1":"default~kyc-kyc-module-ngfactory~modules-crowd-funding-crowd-funding-module-ngfactory~modules-loan-l~298e85a1","default~kyc-kyc-module-ngfactory~modules-crowd-funding-crowd-funding-module-ngfactory~modules-loan-l~932e9662":"default~kyc-kyc-module-ngfactory~modules-crowd-funding-crowd-funding-module-ngfactory~modules-loan-l~932e9662","default~modules-crowd-funding-crowd-funding-module-ngfactory~modules-invoice-invoice-module-ngfactor~cdd0ab35":"default~modules-crowd-funding-crowd-funding-module-ngfactory~modules-invoice-invoice-module-ngfactor~cdd0ab35","default~modules-crowd-funding-crowd-funding-module-ngfactory~modules-loan-loan-module-ngfactory":"default~modules-crowd-funding-crowd-funding-module-ngfactory~modules-loan-loan-module-ngfactory","modules-crowd-funding-crowd-funding-module-ngfactory":"modules-crowd-funding-crowd-funding-module-ngfactory","default~kyc-kyc-module-ngfactory~modules-invoice-invoice-module-ngfactory~modules-loan-loan-module-n~d9bda8f2":"default~kyc-kyc-module-ngfactory~modules-invoice-invoice-module-ngfactory~modules-loan-loan-module-n~d9bda8f2","default~kyc-kyc-module-ngfactory~modules-loan-loan-module-ngfactory":"default~kyc-kyc-module-ngfactory~modules-loan-loan-module-ngfactory","kyc-kyc-module-ngfactory":"kyc-kyc-module-ngfactory","modules-loan-loan-module-ngfactory":"modules-loan-loan-module-ngfactory","default~modules-fund-fund-module-ngfactory~views-user-user-module-ngfactory":"default~modules-fund-fund-module-ngfactory~views-user-user-module-ngfactory","views-user-user-module-ngfactory":"views-user-user-module-ngfactory","modules-invoice-invoice-module-ngfactory":"modules-invoice-invoice-module-ngfactory","modules-reports-reports-module-ngfactory":"modules-reports-reports-module-ngfactory","views-setting-setting-module-ngfactory":"views-setting-setting-module-ngfactory","modules-fund-fund-module-ngfactory":"modules-fund-fund-module-ngfactory","modules-logs-logs-module-ngfactory":"modules-logs-logs-module-ngfactory","views-base-base-module-ngfactory":"views-base-base-module-ngfactory","views-test-test-module-ngfactory":"views-test-test-module-ngfactory","default~views-dashboard-core-ui-dashboard-module-ngfactory~views-theme-theme-module-ngfactory~views-~48223d2d":"default~views-dashboard-core-ui-dashboard-module-ngfactory~views-theme-theme-module-ngfactory~views-~48223d2d","views-dashboard-core-ui-dashboard-module-ngfactory":"views-dashboard-core-ui-dashboard-module-ngfactory","views-theme-theme-module-ngfactory":"views-theme-theme-module-ngfactory","views-widgets-widgets-module-ngfactory":"views-widgets-widgets-module-ngfactory","views-buttons-buttons-module-ngfactory":"views-buttons-buttons-module-ngfactory","views-chartjs-chartjs-module-ngfactory":"views-chartjs-chartjs-module-ngfactory","views-icons-icons-module-ngfactory":"views-icons-icons-module-ngfactory","views-logout-logout-module-ngfactory":"views-logout-logout-module-ngfactory","views-notifications-notifications-module-ngfactory":"views-notifications-notifications-module-ngfactory"}[chunkId]||chunkId) + "." + {"coreui-coreui-module-ngfactory":"0ee46257fe256a962460","default~app-modules-app-version-app-version-module-ngfactory~app-views-setting-global-setting-global~f1cbe40b":"e54bed13ad72250b64c9","common":"4e86649ee79be1a04983","app-views-setting-global-setting-global-module-ngfactory":"6abf0c8efc0818b3dc0b","views-dashboard-dashboard-module-ngfactory":"5d18166abad912f20b66","views-forgot-password-forgot-password-module-ngfactory":"616a7d1246236e2cebe9","views-login-login-module-ngfactory":"6486708368ce98a5a8a7","views-password-reset-password-reset-module-ngfactory":"e989aa8c50d68b215bec","default~app-modules-app-version-app-version-module-ngfactory~bank-bank-module-ngfactory~kyc-kyc-modu~3e2f785a":"c60dcf78a8a311208201","app-modules-app-version-app-version-module-ngfactory":"62a1545fb7336ff8995c","bank-bank-module-ngfactory":"ac38cf39b069e4e1eb7e","views-staff-staff-module-ngfactory":"3d72ead41ab5c3ea3d57","default~kyc-kyc-module-ngfactory~modules-crowd-funding-crowd-funding-module-ngfactory~modules-loan-l~298e85a1":"90de8cb782fed8ee1132","default~kyc-kyc-module-ngfactory~modules-crowd-funding-crowd-funding-module-ngfactory~modules-loan-l~932e9662":"49356639042a27314589","default~modules-crowd-funding-crowd-funding-module-ngfactory~modules-invoice-invoice-module-ngfactor~cdd0ab35":"6d7da05c6859745179c1","default~modules-crowd-funding-crowd-funding-module-ngfactory~modules-loan-loan-module-ngfactory":"1472597aca07dde8d35a","modules-crowd-funding-crowd-funding-module-ngfactory":"87563ad457daacf6db4f","default~kyc-kyc-module-ngfactory~modules-invoice-invoice-module-ngfactory~modules-loan-loan-module-n~d9bda8f2":"0485d3c663d810500d29","default~kyc-kyc-module-ngfactory~modules-loan-loan-module-ngfactory":"8996f36e503a57c7f1e0","kyc-kyc-module-ngfactory":"3b9b16dd19e91183229a","modules-loan-loan-module-ngfactory":"f19d3a4f73a3e82ae5dc","default~modules-fund-fund-module-ngfactory~views-user-user-module-ngfactory":"3ac7a9053eb3233996e3","views-user-user-module-ngfactory":"7c0e294de35d230e4bd8","modules-invoice-invoice-module-ngfactory":"99a1cdf92b0fcddd20f5","modules-reports-reports-module-ngfactory":"d2edc624d86d5a93e97b","views-setting-setting-module-ngfactory":"7d5eff9fdea364778054","modules-fund-fund-module-ngfactory":"3670d085ae1deca0b0a8","modules-logs-logs-module-ngfactory":"7a063d893af5edb549c2","views-base-base-module-ngfactory":"3013052a4475860ae9a3","views-test-test-module-ngfactory":"6cf8a9e932479aaff46c","default~views-dashboard-core-ui-dashboard-module-ngfactory~views-theme-theme-module-ngfactory~views-~48223d2d":"3c7144ded1ccd94e7ac4","views-dashboard-core-ui-dashboard-module-ngfactory":"67977e1d694fb9e055a5","views-theme-theme-module-ngfactory":"9635f85840b5f186f968","views-widgets-widgets-module-ngfactory":"f52f598566d5b6152487","views-buttons-buttons-module-ngfactory":"ae845f45b8c01525401c","views-chartjs-chartjs-module-ngfactory":"ab575e8421de4fe6b2e4","views-icons-icons-module-ngfactory":"2df7f6f5d17caa9b0d45","views-logout-logout-module-ngfactory":"51ab4cdec64889e2ed6f","views-notifications-notifications-module-ngfactory":"42f08663729fc3f8e2c8"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
